import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    message: '',
    recipient_email: 'contact.amd.immo@gmail.com'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nom', formData.nom);
      formBody.append('email', formData.email);
      formBody.append('telephone', formData.telephone);
      formBody.append('message', formData.message);
      formBody.append('recipient_email', formData.recipient_email);

      const response = await fetch('https://readdy.ai/api/form/d60eflmmq2rq4g9vor80', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nom: '', email: '', telephone: '', message: '', recipient_email: 'contact.amd.immo@gmail.com' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="relative py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/12facbe7c18191d2c911acc95992b97e.jpg"
          alt="Contact"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1A3B5C]/70"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-5xl md:text-6xl font-bold leading-tight mb-8">
              Prêt à Protéger<br />Votre Patrimoine ?
            </h2>

            <a
              href="https://wa.me/221XXXXXXXXX"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-white text-[#1A3B5C] rounded-full pr-3 pl-8 py-4 hover:shadow-2xl transition-all duration-300 hover:scale-105 mb-8 cursor-pointer group whitespace-nowrap"
            >
              <span className="font-bold text-lg mr-4">Contacter sur WhatsApp</span>
              <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center group-hover:bg-[#25D366] transition-colors">
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </div>
            </a>

            <div className="space-y-4 mt-8">
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-[#C9A961] text-2xl"></i>
                <div>
                  <p className="text-white text-lg font-medium">contact.amd.immo@gmail.com</p>
                  <p className="text-white/80 text-sm">Réponse sous 2h</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-[#C9A961] text-2xl"></i>
                <div>
                  <p className="text-white text-lg font-medium">Lun - Sam : 8h - 18h</p>
                  <p className="text-white/80 text-sm">Urgences 24/7</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10">
            <h3 className="text-2xl font-bold text-[#1A3B5C] mb-6">
              Demander un audit gratuit
            </h3>

            <form onSubmit={handleSubmit} data-readdy-form id="contact-form">
              <input type="hidden" name="recipient_email" value="contact.amd.immo@gmail.com" />
              <div className="space-y-4">
                <div>
                  <label htmlFor="nom" className="block text-sm font-medium text-gray-700 mb-2">
                    Nom complet *
                  </label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    required
                    value={formData.nom}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1A3B5C] focus:border-transparent outline-none transition-all"
                    placeholder="Votre nom"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1A3B5C] focus:border-transparent outline-none transition-all"
                    placeholder="votre@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="telephone" className="block text-sm font-medium text-gray-700 mb-2">
                    Téléphone *
                  </label>
                  <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    required
                    value={formData.telephone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1A3B5C] focus:border-transparent outline-none transition-all"
                    placeholder="+221 XX XXX XX XX"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    maxLength={500}
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1A3B5C] focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Parlez-nous de votre bien (localisation, type, besoins...)"
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">Maximum 500 caractères</p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#1A3B5C] text-white py-4 rounded-lg hover:bg-[#2A4B6C] transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Envoi en cours...' : 'Envoyer ma demande'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-[#1A3B5C]/5 border-2 border-[#C9A961] rounded-xl p-6">
                    <div className="flex items-start space-x-3 mb-4">
                      <div className="w-8 h-8 bg-[#C9A961] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-white text-xl"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-[#1A3B5C] text-lg mb-2">
                          Confirmation de réception de votre demande
                        </h4>
                        <p className="text-gray-700 text-sm leading-relaxed mb-3">
                          Bonjour,
                        </p>
                        <p className="text-gray-700 text-sm leading-relaxed mb-3">
                          Votre demande a bien été reçue par <strong>AMD Immo – Gestion Immobilière & Conciergerie Premium</strong>.
                        </p>
                        <p className="text-gray-700 text-sm leading-relaxed mb-3">
                          Un membre de notre équipe vous recontactera dans les plus brefs délais.
                        </p>
                        <p className="text-gray-700 text-sm leading-relaxed mb-3">
                          Nous vous remercions pour votre confiance.
                        </p>
                        <p className="text-[#1A3B5C] font-semibold text-sm mt-4">
                          L'équipe AMD Immo
                        </p>
                        <p className="text-[#C9A961] italic text-sm">
                          La tranquillité de vos biens, même à distance.
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
                    <p className="font-medium">Une erreur est survenue.</p>
                    <p className="text-sm">Veuillez réessayer ou nous contacter par WhatsApp.</p>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
